import History from 'appHistory';
import {routerMiddleware} from 'connected-react-router';
import {applyMiddleware, compose, createStore, Store} from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducerWithHistory, {ReducerState} from 'rootReducer';
import rootSaga from 'rootSaga';

const sagaMiddleware = createSagaMiddleware();

export function enableReduxHMR(mod: any, store: Store<ReducerState>) {
  if (mod.hot) {
    mod.hot.accept('rootReducer', (nextRootReducer: any) => {
      store.replaceReducer(nextRootReducer);
    });
  }
}

const configureStore = (enableHMR: typeof enableReduxHMR, initialState?: ReducerState) => {
  const composeEnhancers =
    // @ts-ignore
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    rootReducerWithHistory(History),
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(History)))
  ) as Store<ReducerState>;

  sagaMiddleware.run(rootSaga);

  if (process.env.NODE_ENV === 'development') {
    enableHMR(module, store);
  }

  return store;
};

const store = configureStore(enableReduxHMR);

export default store;
